import { render, staticRenderFns } from "./CreateSearchCampaign.vue?vue&type=template&id=5bd1e726&"
import script from "./CreateSearchCampaign.vue?vue&type=script&lang=ts&"
export * from "./CreateSearchCampaign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports